<template>
  <div class="pub-page">
    <div class="pub-hero">
      <div>
        <span class="pub-hero__kicker">Convocatoria masiva</span>
        <h1 class="pub-hero__title">Postulacion abierta</h1>
        <p class="pub-hero__subtitle">
          Completa tus datos y selecciona los cargos de interes.
        </p>
      </div>
    </div>

    <v-container class="pub-container">
      <v-card class="pub-card" outlined>
        <v-card-text>
          <div v-if="loading" class="pub-loading">
            <v-progress-circular indeterminate color="primary" />
            <p>Cargando convocatoria...</p>
          </div>

          <div v-else>
            <div v-if="!massiveDetail" class="pub-empty">
              Convocatoria no encontrada o vencida.
            </div>

            <div v-else-if="positions.length === 0" class="pub-empty">
              No hay cargos disponibles para esta convocatoria.
            </div>

            <div v-else>
              <div class="pub-info">
                <div>
                  <span>Campana</span>
                  <strong>{{ massiveDetail.CmpName }}</strong>
                </div>
                <div>
                  <span>Estado</span>
                  <strong>{{
                    massiveDetail.MrcStatusName || "Cerrada"
                  }}</strong>
                </div>
              </div>

              <div>
                <h3 class="pub-step-title">
                  Completa tus datos y selecciona hasta 3 cargos
                </h3>
                <v-row>
                  <v-col cols="12" md="4">
                    <s-text
                      number
                      ref="dniInput"
                      v-model="personData.PrsDocumentNumber"
                      label="DNI*"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <s-text
                      ref="nameInput"
                      v-model="personData.NtpName"
                      label="Nombres*"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Nombres requeridos']"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <s-text
                      ref="paternalSurnameInput"
                      v-model="personData.NtpPaternalSurname"
                      label="Apellido Paterno*"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Apellido paterno requerido']"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <s-text
                      ref="maternalSurnameInput"
                      v-model="personData.NtpMaternalSurname"
                      label="Apellido Materno*"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Apellido materno requerido']"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <s-date
                      ref="birthDateInput"
                      v-model="personData.NtpBirthDate"
                      label="Fecha de Nacimiento*"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Fecha de nacimiento requerida']"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <s-select
                      ref="genderInput"
                      v-model="personData.TypeSex"
                      :items="[
                        { value: 1, text: 'Masculino' },
                        { value: 2, text: 'Femenino' },
                      ]"
                      item-text="text"
                      item-value="value"
                      label="Género*"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <s-text
                      ref="phoneInput"
                      v-model="personData.PpnNumberPhone"
                      label="Teléfono*"
                      outlined
                      dense
                      type="tel"
                      :rules="[
                        (v) => !!v || 'Teléfono requerido',
                        (v) =>
                          /^\d{9}$/.test(v) || 'Teléfono debe tener 9 dígitos',
                      ]"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text
                      ref="emailInput"
                      v-model="personData.PemEmail"
                      label="Email*"
                      outlined
                      dense
                      type="email"
                      :rules="[
                        (v) => !!v || 'Email requerido',
                        (v) => /.+@.+\..+/.test(v) || 'Email inválido',
                      ]"
                    />
                    <v-checkbox
                      v-model="personData.IsOwnEmail"
                      label="¿El correo electrónico es propio?"
                      dense
                      hide-details
                      class="mt-1"
                      :disabled="isSubmitted"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <s-text
                      ref="addressInput"
                      v-model="personData.PadAddress"
                      label="Dirección*"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Dirección requerida']"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <s-select-public-definition
                      ref="typeTurnInput"
                      v-model="personData.TypeTurn"
                      :def="1278"
                      label="Turno"
                      clearable
                      outlined
                      dense
                      :disabled="isSubmitted"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text
                      ref="previousCampaignsInput"
                      number
                      v-model="personData.PreviousCampaigns"
                      label="Campañas anteriores"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col cols="12" md="12">
                  <s-select-public-definition
                    ref="processFilterInput"
                    v-model="selectedTypeProcess"
                    :def="1077"
                    label="Filtrar cargos por proceso"
                    clearable
                    outlined
                    dense
                    :disabled="isSubmitted"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <div style="padding-top: -2px; margin-top: -2px">
                    <v-label>
                      <b>Cargos disponibles</b>
                    </v-label>
                    <v-select
                      ref="positionsInput"
                      v-model="selectedPositions"
                      :items="selectablePositions"
                      item-text="PstName"
                      item-value="PstID"
                      item-disabled="_disabled"
                      multiple
                      outlined
                      dense
                      hide-details="auto"
                      placeholder=" "
                      :disabled="isSubmitted"
                      persistent-hint
                      :hint="`${selectedPositions.length}/3 cargos seleccionados`"
                    />
                  </div>
                </v-col>
              </v-row>

              <div class="pub-consent">
                <v-checkbox
                  ref="consentCheckbox"
                  :input-value="consentAccepted"
                  class="mt-2"
                  readonly
                  hide-details
                  label="He leído y acepto los términos y el consentimiento para tratamiento de datos personales"
                />
                <v-btn
                  text
                  color="primary"
                  class="px-0"
                  :disabled="isSubmitted"
                  @click="termsDialog = true"
                >
                  Ver términos y condiciones
                </v-btn>
              </div>

              <div class="pub-actions">
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="isSubmitted"
                  @click="submit"
                >
                  Enviar postulacion
                </v-btn>
                <v-btn
                  v-if="isSubmitted"
                  class="ml-2"
                  color="#065f46"
                  outlined
                  @click="resetForNewRegistration"
                >
                  Realizar otro registro
                </v-btn>
              </div>

              <div v-if="isSubmitted" class="pub-person-ok mt-4">
                <strong>✓ Registro enviado</strong>
                <div>Tu postulación ya fue registrada para esta campaña.</div>
              </div>
            </div>
          </div>

          <terms-convocatory
            v-model="termsDialog"
            @accepted="onTermsAccepted"
          />

          <!-- reCAPTCHA v2 Invisible Widget -->
          <div id="recaptcha-container"></div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import TermsConvocatory from "@/components/HumanResource/RecruitmentMassive/TermsConvocatory.vue";
import MassiveService from "@/services/HumanResource/RecruitmentMassive/HmnMassiveRecruitmentService";
import PublicRecruitmentService from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentService";

export default {
  name: "PublicConvocatoria",
  components: {
    SText,
    TermsConvocatory,
  },
  computed: {
    filteredPositions() {
      if (!this.selectedTypeProcess) {
        return this.positions;
      }
      return this.positions.filter(
        (p) =>
          p.TypeProcess === this.selectedTypeProcess ||
          String(p.TypeProcess) === String(this.selectedTypeProcess),
      );
    },
    selectablePositions() {
      return this.filteredPositions.map((p) => ({
        ...p,
        _disabled:
          this.selectedPositions.length >= 3 &&
          !this.selectedPositions.includes(p.PstID),
      }));
    },
  },
  data() {
    const recaptchaSiteKey =
      //isLocalHost
      "6Ld8Z34sAAAAAILBWXKeRpEbJcFZuAFUEmiXvpDw";
    //: (process.env.VUE_APP_RECAPTCHA_SITE_KEY || "");

    return {
      loading: true,
      saving: false,

      // reCAPTCHA v2 configuration
      recaptchaSiteKey,
      recaptchaWidgetId: null,
      recaptchaReady: false,
      recaptchaTokenResolver: null,
      recaptchaTokenRejecter: null,
      recaptchaTokenTimeout: null,
      recaptchaTokenPoller: null,

      massiveDetail: null,
      isSubmitted: false,
      selectedTypeProcess: null,
      positions: [],
      selectedPositions: [],
      personData: {
        PrsDocumentNumber: "",
        NtpName: "",
        NtpPaternalSurname: "",
        NtpMaternalSurname: "",
        NtpBirthDate: null,
        TypeSex: 1,
        PpnNumberPhone: "",
        PemEmail: "",
        IsOwnEmail: true,
        PadAddress: "",
        TypeTurn: null,
        PreviousCampaigns: 0,
      },
      consentAccepted: false,
      termsDialog: false,
      form: {
        MrcID: 0,
        PositionIDsJSON: "[]",
      },
    };
  },
  created() {
    this.loadConvocatoria();
  },
  mounted() {
    this.loadRecaptchaScript();
  },
  methods: {
    // ==================== reCAPTCHA METHODS ====================

    loadRecaptchaScript() {
      // Cargar script de reCAPTCHA v2 si no está cargado
      if (window.grecaptcha) {
        this.initRecaptcha();
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
      script.async = true;
      script.defer = true;

      window.onRecaptchaLoad = () => {
        this.initRecaptcha();
      };

      document.head.appendChild(script);
    },

    initRecaptcha() {
      if (this.recaptchaWidgetId !== null) {
        this.recaptchaReady = true;
        return;
      }

      const placeholderElement = document.getElementById("recaptcha-container");
      if (!placeholderElement) {
        setTimeout(() => this.initRecaptcha(), 120);
        return;
      }

      if (!window.grecaptcha || !window.grecaptcha.render) {
        setTimeout(() => this.initRecaptcha(), 100);
        return;
      }

      if (!this.recaptchaSiteKey) {
        this.$fun.alert(
          "Falta configurar VUE_APP_RECAPTCHA_SITE_KEY para este entorno.",
          "warning",
        );
        return;
      }

      try {
        this.recaptchaWidgetId = window.grecaptcha.render(
          "recaptcha-container",
          {
            sitekey: this.recaptchaSiteKey,
            size: "invisible",
            callback: (token) => {
              if (this.recaptchaTokenTimeout) {
                clearTimeout(this.recaptchaTokenTimeout);
                this.recaptchaTokenTimeout = null;
              }
              if (this.recaptchaTokenPoller) {
                clearInterval(this.recaptchaTokenPoller);
                this.recaptchaTokenPoller = null;
              }
              if (this.recaptchaTokenResolver) {
                this.recaptchaTokenResolver(token);
                this.recaptchaTokenResolver = null;
                this.recaptchaTokenRejecter = null;
              }
            },
            "error-callback": () => {
              if (this.recaptchaTokenTimeout) {
                clearTimeout(this.recaptchaTokenTimeout);
                this.recaptchaTokenTimeout = null;
              }
              if (this.recaptchaTokenPoller) {
                clearInterval(this.recaptchaTokenPoller);
                this.recaptchaTokenPoller = null;
              }
              if (this.recaptchaTokenRejecter) {
                this.recaptchaTokenRejecter(new Error("Error en reCAPTCHA"));
                this.recaptchaTokenResolver = null;
                this.recaptchaTokenRejecter = null;
              }
            },
            "expired-callback": () => {
              if (this.recaptchaTokenTimeout) {
                clearTimeout(this.recaptchaTokenTimeout);
                this.recaptchaTokenTimeout = null;
              }
              if (this.recaptchaTokenPoller) {
                clearInterval(this.recaptchaTokenPoller);
                this.recaptchaTokenPoller = null;
              }
              if (this.recaptchaTokenRejecter) {
                this.recaptchaTokenRejecter(new Error("reCAPTCHA expirado"));
                this.recaptchaTokenResolver = null;
                this.recaptchaTokenRejecter = null;
              }
            },
          },
        );
        this.recaptchaReady = true;
        console.log("reCAPTCHA inicializado correctamente");
      } catch (error) {
        console.error("Error al inicializar reCAPTCHA:", error);
      }
    },

    async getRecaptchaToken() {
      if (!this.recaptchaReady || !window.grecaptcha) {
        this.$fun.alert(
          "reCAPTCHA no está listo. Recarga la página.",
          "warning",
        );
        return null;
      }

      try {
        // Si ya existe token vigente, reutilizarlo.
        const cachedToken = window.grecaptcha.getResponse(
          this.recaptchaWidgetId,
        );
        if (cachedToken) {
          return cachedToken;
        }

        if (this.recaptchaTokenTimeout) {
          clearTimeout(this.recaptchaTokenTimeout);
          this.recaptchaTokenTimeout = null;
        }

        if (this.recaptchaTokenPoller) {
          clearInterval(this.recaptchaTokenPoller);
          this.recaptchaTokenPoller = null;
        }

        if (this.recaptchaTokenRejecter) {
          this.recaptchaTokenRejecter(
            new Error("Solicitud reCAPTCHA reemplazada"),
          );
        }

        const tokenPromise = new Promise((resolve, reject) => {
          this.recaptchaTokenResolver = resolve;
          this.recaptchaTokenRejecter = reject;

          // Fallback: en algunos navegadores el callback no retorna, pero getResponse sí contiene token.
          this.recaptchaTokenPoller = setInterval(() => {
            const responseToken = window.grecaptcha.getResponse(
              this.recaptchaWidgetId,
            );
            if (responseToken) {
              if (this.recaptchaTokenTimeout) {
                clearTimeout(this.recaptchaTokenTimeout);
                this.recaptchaTokenTimeout = null;
              }
              clearInterval(this.recaptchaTokenPoller);
              this.recaptchaTokenPoller = null;

              if (this.recaptchaTokenResolver) {
                this.recaptchaTokenResolver(responseToken);
                this.recaptchaTokenResolver = null;
                this.recaptchaTokenRejecter = null;
              }
            }
          }, 300);

          this.recaptchaTokenTimeout = setTimeout(() => {
            this.recaptchaTokenTimeout = null;
            if (this.recaptchaTokenPoller) {
              clearInterval(this.recaptchaTokenPoller);
              this.recaptchaTokenPoller = null;
            }
            this.recaptchaTokenResolver = null;
            this.recaptchaTokenRejecter = null;
            reject(new Error("Timeout obteniendo token de reCAPTCHA"));
          }, 120000);
        });

        // Ejecutar reCAPTCHA invisible
        window.grecaptcha.execute(this.recaptchaWidgetId);

        return await tokenPromise;
      } catch (error) {
        console.error("Error al obtener token de reCAPTCHA:", error);
        this.$fun.alert(
          "No se pudo validar reCAPTCHA. Verifica bloqueadores/extensiones y vuelve a intentar.",
          "error",
        );
        return null;
      } finally {
        if (this.recaptchaTokenPoller) {
          clearInterval(this.recaptchaTokenPoller);
          this.recaptchaTokenPoller = null;
        }
      }
    },

    // ==================== CORE METHODS ====================

    async loadConvocatoria() {
      const uuid = this.$route.params.uuid;
      if (!uuid) return;
      this.loading = true;
      try {
        const response = await MassiveService.byUUID(uuid);
        if (response.status === 200) {
          this.massiveDetail = response.data;
          this.form.MrcID = response.data.MrcID;
          await this.loadCargos(response.data.CmpID);
        }
      } catch (error) {
        this.massiveDetail = null;
      } finally {
        this.loading = false;
      }
    },

    async loadCargos(cmpID) {
      const response = await MassiveService.GetAvailablePositions(cmpID);
      if (response.status === 200) this.positions = response.data;
    },

    resetForNewRegistration() {
      this.personData = {
        PrsDocumentNumber: "",
        NtpName: "",
        NtpPaternalSurname: "",
        NtpMaternalSurname: "",
        NtpBirthDate: null,
        TypeSex: 1,
        PpnNumberPhone: "",
        PemEmail: "",
        IsOwnEmail: true,
        PadAddress: "",
        TypeTurn: null,
        PreviousCampaigns: 0,
      };
      this.selectedPositions = [];
      this.selectedTypeProcess = null;
      this.form.PositionIDsJSON = "[]";
      this.isSubmitted = false;
      this.consentAccepted = false;
      this.termsDialog = false;

      if (window.grecaptcha && this.recaptchaWidgetId !== null) {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      }
    },

    async submit() {
      if (this.isSubmitted) {
        this.$fun.alert(
          "Tu postulación ya fue registrada para esta campaña.",
          "info",
        );
        return;
      }

      if (!this.personData.PrsDocumentNumber) {
        this.$fun.focusFieldError(this, "dniInput", "DNI requerido");
        this.$fun.alert("DNI requerido");
        return;
      }
      if (
        !this.personData.NtpName ||
        !this.personData.NtpPaternalSurname ||
        !this.personData.NtpMaternalSurname
      ) {
        if (!this.personData.NtpName) {
          this.$fun.focusFieldError(this, "nameInput", "Nombres requeridos");
        } else if (!this.personData.NtpPaternalSurname) {
          this.$fun.focusFieldError(
            this,
            "paternalSurnameInput",
            "Apellido paterno requerido",
          );
        } else if (!this.personData.NtpMaternalSurname) {
          this.$fun.focusFieldError(
            this,
            "maternalSurnameInput",
            "Apellido materno requerido",
          );
        }
        this.$fun.alert("Nombres y apellidos son requeridos", "warning");
        return;
      }
      if (!this.personData.NtpBirthDate) {
        this.$fun.focusFieldError(
          this,
          "birthDateInput",
          "Fecha de nacimiento requerida",
        );
        this.$fun.alert("Fecha de nacimiento requerida", "warning");
        return;
      }

      const birthDate = new Date(this.personData.NtpBirthDate);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      if (
        age < 18 ||
        (age === 18 &&
          today < new Date(birthDate.setFullYear(birthDate.getFullYear() + 18)))
      ) {
        this.$fun.focusFieldError(
          this,
          "birthDateInput",
          "Debes ser mayor de 18 años",
        );
        this.$fun.alert("Debes ser mayor de 18 años", "warning");
        return;
      }

      if (
        !this.personData.PpnNumberPhone ||
        !/^\d{9}$/.test(this.personData.PpnNumberPhone)
      ) {
        this.$fun.focusFieldError(
          this,
          "phoneInput",
          "Teléfono requerido y debe tener 9 dígitos",
        );
        this.$fun.alert("Teléfono debe tener 9 dígitos", "warning");
        return;
      }
      if (
        !this.personData.PemEmail ||
        !/.+@.+\..+/.test(this.personData.PemEmail)
      ) {
        this.$fun.focusFieldError(this, "emailInput", "Email inválido");
        this.$fun.alert("Email inválido", "warning");
        return;
      }
      if (!this.personData.PadAddress) {
        this.$fun.focusFieldError(this, "addressInput", "Dirección requerida");
        this.$fun.alert("Dirección requerida", "warning");
        return;
      }
      if (!this.personData.TypeTurn) {
        this.$fun.focusFieldError(
          this,
          "typeTurnInput",
          "Selecciona un turno de preferencia",
        );
        this.$fun.alert("Selecciona un turno de preferencia", "warning");
        return;
      }

      if (!this.consentAccepted) {
        this.$fun.focusFieldError(
          this,
          "consentCheckbox",
          "Debes aceptar los términos y consentimiento de datos",
        );
        this.$fun.alert(
          "Debes aceptar los términos y consentimiento de datos para continuar",
          "warning",
        );
        this.termsDialog = true;
        return;
      }

      if (!this.selectedPositions.length) {
        this.$fun.focusFieldError(
          this,
          "positionsInput",
          "Selecciona al menos un cargo",
        );
        this.$fun.alert("Selecciona al menos un cargo", "warning");
        return;
      }
      if (this.selectedPositions.length > 3) {
        this.$fun.focusFieldError(
          this,
          "positionsInput",
          "Solo puedes seleccionar hasta 3 cargos",
        );
        this.$fun.alert("Solo puedes seleccionar hasta 3 cargos", "warning");
        return;
      }

      this.saving = true;
      try {
        const recaptchaToken = await this.getRecaptchaToken();
        if (!recaptchaToken) return;

        this.form.PositionIDsJSON = JSON.stringify(this.selectedPositions);
        const payload = {
          MrcID: this.form.MrcID,
          PrsDocumentNumber: this.personData.PrsDocumentNumber.trim(),
          NtpName: this.personData.NtpName,
          NtpPaternalSurname: this.personData.NtpPaternalSurname,
          NtpMaternalSurname: this.personData.NtpMaternalSurname,
          NtpBirthDate: this.personData.NtpBirthDate,
          TypeSex: this.personData.TypeSex,
          PpnNumberPhone: this.personData.PpnNumberPhone,
          PemEmail: this.personData.PemEmail,
          IsOwnEmail: this.personData.IsOwnEmail,
          PadAddress: this.personData.PadAddress,
          TypeTurn: this.personData.TypeTurn,
          PreviousCampaigns:
            this.personData.PreviousCampaigns != null &&
            this.personData.PreviousCampaigns !== ""
              ? parseInt(this.personData.PreviousCampaigns)
              : 0,
          ConsentAccepted: this.consentAccepted,
          PositionIDsJSON: this.form.PositionIDsJSON,
        };

        await PublicRecruitmentService.publicSave(payload, recaptchaToken);
        this.isSubmitted = true;
        this.$fun.alert("Postulación enviada", "success");
      } catch (error) {
        console.log("Error al enviar postulación:", error);
        const message =
          error?.response?.data?.Message ||
          error?.response?.data ||
          error?.message ||
          "No se pudo enviar";
        if (
          typeof message === "string" &&
          message.includes("Ya existe una postulación")
        ) {
          this.isSubmitted = true;
        }
        this.$fun.alert(message, "warning");
      } finally {
        this.saving = false;
      }
    },
    onTermsAccepted() {
      this.consentAccepted = true;
      this.termsDialog = false;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:wght@600&family=Manrope:wght@400;600;700&display=swap");

.pub-page {
  --ink: #0f172a;
  --muted: #64748b;
  --primary: #0f766e;
  --primary-hover: #0d5e58;
  --border: #e2e8f0;

  background: radial-gradient(
    circle at 0% 0%,
    #f0fdf4 0%,
    #f8fafc 50%,
    #f1f5f9 100%
  );
  min-height: 100vh;
  padding: 40px 20px;
  font-family: "Manrope", sans-serif;
  color: var(--ink);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pub-hero {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: #f8fafc;
  padding: 32px 40px;
  border-radius: 24px;
  margin-bottom: 24px;
  width: 100%;
  max-width: 900px;
  box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.1),
    0 8px 10px -6px rgba(15, 23, 42, 0.1);
  position: relative;
  overflow: hidden;
}

.pub-hero::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -20%;
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(15, 118, 110, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
}

.pub-hero__kicker {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  font-weight: 700;
  color: #2dd4bf;
  display: inline-block;
  margin-bottom: 4px;
}

.pub-hero__title {
  font-family: "Fraunces", serif;
  font-size: 2rem;
  margin: 6px 0 8px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.pub-hero__subtitle {
  margin: 0;
  color: #94a3b8;
  font-size: 0.95rem;
}

.pub-container {
  width: 100%;
  max-width: 900px;
  padding: 0;
}

.pub-card {
  border-radius: 24px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05),
    0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  padding: 16px;
}

.pub-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 0;
  color: var(--muted);
}

.pub-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--muted);
  font-size: 1.05rem;
}

.pub-info {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background: #f8fafc;
  padding: 16px 24px;
  border-radius: 16px;
  margin-bottom: 28px;
  border: 1px solid rgba(226, 232, 240, 0.6);
}

.pub-info span {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
  margin-bottom: 2px;
}

.pub-info strong {
  color: var(--ink);
  font-size: 1.05rem;
}

.pub-step-title {
  margin-bottom: 20px;
  color: var(--ink);
  font-weight: 700;
  font-size: 1.2rem;
  letter-spacing: -0.01em;
}

.pub-consent {
  margin-top: 16px;
  background: #f8fafc;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid var(--border);
}

.pub-consent :deep(.v-label) {
  font-size: 0.875rem !important;
  color: #475569 !important;
}

.pub-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.pub-actions :deep(.v-btn) {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0px !important;
  height: 48px !important;
  padding: 0 24px !important;
  transition: all 0.2s ease-in-out !important;
}

.pub-actions :deep(.v-btn.primary) {
  background: var(--primary) !important;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.2) !important;
}

.pub-actions :deep(.v-btn.primary:hover) {
  background: var(--primary-hover) !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 118, 110, 0.3) !important;
}

.pub-person-ok {
  width: 100%;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 16px;
  padding: 16px 20px;
  color: #065f46;
  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.05);
}

.pub-person-ok strong {
  display: block;
  font-size: 1rem;
  margin-bottom: 4px;
}

.pub-person-ok div {
  font-size: 0.875rem;
  opacity: 0.9;
}

/* Customizing inputs to be sleeker */
:deep(.v-text-field--outlined .v-input__control .v-input__slot) {
  border-radius: 12px !important;
  background-color: #f8fafc !important;
  border-color: rgba(226, 232, 240, 0.8) !important;
}

:deep(
    .v-text-field--outlined.v-input--is-focused .v-input__control .v-input__slot
  ) {
  background-color: #ffffff !important;
  border-color: var(--primary) !important;
}

:deep(.v-text-field--outlined .v-input__control .v-input__slot fieldset) {
  border-color: rgba(226, 232, 240, 0.8) !important;
  border-width: 1px !important;
}

:deep(
    .v-text-field--outlined.v-input--is-focused
      .v-input__control
      .v-input__slot
      fieldset
  ) {
  border-color: var(--primary) !important;
  border-width: 2px !important;
}

:deep(.v-label) {
  font-size: 0.875rem !important;
}

#recaptcha-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}
</style>
